import "./styles.css"
import success from '../../images/ssuccess.png'
import { useContext, useEffect, useState } from "react"


import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseFunctions/authhook";
import { idContext } from "../../App";

const Success: React.FC = () => {
  const [id, setId] = useContext(idContext);
  const [userData, setUserData] = useState<object | any>({});

  useEffect(() => {
    const getUserData = async () => {
      const docRef = doc(db, "appointment_lists", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setUserData(docSnap.data());
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }
    if (id) {
      getUserData();
    }
  }, [id]);
  const today = new Date(userData.date);
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = Number(today.getMonth()); 
  var yyyy = today.getFullYear();


  return (
    <div className="homeDesign flex_design">
      <div className="serialNumber">
     {
      Object.keys(userData).length > 0 &&
      <>
         <p>رقمك هو</p>
         <p>{userData.serialNumber}</p>
      <p>{dd}-{mm + 1}-{yyyy}</p>
      </>
     }
      </div>
      <div className="success">
        <img src={success} alt="" />
      </div>
      <p className="txt_style">تم الحجز بنجاح</p>
      <br />
      <p className= "textapp09">الرجاء إبراز صورة من الحجز عند الحضور</p>
    </div>
  )
}

export default Success;
